export const toSwanLocale = (locale: string): string => locale.toLowerCase().replace(/_/g, '-');

export const loadSwanTranslations = async (locale: string): Promise<Record<string, string>> => {
  const swanLocale = toSwanLocale(locale);
  try {
    return (await import(`@vp/swan/i18n/${swanLocale}.json`)).default;
  } catch {
    return (await import('@vp/swan/i18n/en-us.json')).default;
  }
};
